

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M12.9999 1.30005C14.9354 1.30005 16.5099 2.87463 16.5099 4.81005C16.5099 6.74546 14.9354 8.32005 12.9999 8.32005C11.0645 8.32005 9.48995 6.74546 9.48995 4.81005C9.48995 2.87463 11.0645 1.30005 12.9999 1.30005ZM17.6799 24.7001H8.31995V22.6943H10.3257V12.6658H8.31995V10.66H15.6742V22.6943H17.6799V24.7001Z","fill":"#342245"}, []), "\n"]);
};

        